const _excluded = ["intent", "icon", "withAction", "className", "children", "weight", "variant", "hideIcon"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cn from 'classnames';
import { BulbLiner24, DangerLiner24, CloseCircleLiner24 } from "../../icons";
import { Typography } from "../Typography";
import styles from "./Callout.module.scss";
const iconsMap = {
  info: /*#__PURE__*/React.createElement(BulbLiner24, {
    width: 18,
    height: 18
  }),
  warning: /*#__PURE__*/React.createElement(DangerLiner24, {
    width: 18,
    height: 18
  }),
  error: /*#__PURE__*/React.createElement(CloseCircleLiner24, {
    width: 18,
    height: 18
  })
};
export function Callout(props) {
  const {
    intent = 'info',
    icon,
    withAction,
    className,
    children,
    weight,
    variant,
    hideIcon
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cn(styles.root, styles[intent], className)
  }, rest), !hideIcon && /*#__PURE__*/React.createElement("div", {
    className: styles.icon
  }, icon || iconsMap[intent]), /*#__PURE__*/React.createElement(Typography, {
    className: styles.content,
    weight: weight,
    variant: variant
  }, children), withAction);
}